import { useEffect, useState } from "react";
import type { ProductionRun } from "../models";
import { runTimers } from "./run-timers";

export function useRunTimers(run: ProductionRun | null) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!run || run.status === "COMPLETED") return;
    setNow(Date.now());
    const interval = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(interval);
  }, [run?.id, run?.status]);
  return runTimers(run, now);
}
